import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { callAPIWithoutAuth } from '../../utils/apiUtils';
import { apiUrls } from '../../utils/apiUrls';

export const fetchTestimonial = createAsyncThunk(
    'testimonial/fetchTestimonial',
    async (limit = null, { rejectWithValue }) => {
        try {
            const params = {}
            if (limit != null) {
                params.limit = limit
            }
            const response = await callAPIWithoutAuth(
                apiUrls.testimonialListing,
                params,
                "GET",
                {}
            );

            if (response?.data?.success) {
                return response.data.data;
            } else {
                return rejectWithValue(response?.data?.message || 'Failed to fetch categories');
            }
        } catch (error) {
            return rejectWithValue(error.response?.data?.message || 'Network error');
        }
    }
);

const testimonialSlice = createSlice({
    name: 'testimonial',
    initialState: {
        testimonials: [],
        data: [],
        loading: false,
        error: null
    },
    reducers: {
        clearTestimonialError: (state) => {
            state.error = null;
        },
        clearTestimonial: (state) => {
            state.categories = [];
            state.data = [];
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchTestimonial.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchTestimonial.fulfilled, (state, action) => {
                state.loading = false;
                state.testimonials = action.payload;
                state.data = action.payload.data || action.payload;
            })
            .addCase(fetchTestimonial.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });
    }
});

export const { clearTestimonialError, clearTestimonial } = testimonialSlice.actions;
export default testimonialSlice.reducer;